import Container from "../../components/Container";
import {Link} from "react-router";


export default function Hero() {
    return <Container
        transparent
        padding={""}
        shadow={false}
        size={"w-full"}
        className="relative"
        outerPadding={""}
    >
        <div className={`min-w-[100vw] md:min-w-[80dvw]`}>
            <img className="h-[90dvh] w-full object-cover "
                 src="img/musa-ortac-HrrWNCpoOu8-unsplash.jpg" alt="cover-image"/>

            <div
                className="absolute inset-0 bg-gradient-to-br from-gray-700 to-slate-900 opacity-70"></div>

            <div
                className="absolute bottom-0 right-0 w-full flex flex-col md:flex-row justify-between items-center">
                <div
                    className={"pt-24 pb-8 md:pb-16 px-6 md:px-10 space-y-6 text-center md:text-left text-white  rounded-3xl"}>
                    <div>
                        <div className={"font-bold text-2xl md:text-5xl"}>Innovating Property Valuations,</div>
                        <div className={"font-bold text-2xl md:text-5xl"}> Enhancing Property Market</div>
                    </div>
                    <div className={"md:text-lg md:font-semibold text-blue-200"}>
                        We are empowering the real estate stakeholder ecosystem with innovative tools and advanced
                        technologies to support their growth.
                    </div>
                    <div className={"flex flex-col md:flex-row px-10 md:px-0 gap-6"}>
                        <Link to={"/about"}
                              className={"border border-white py-2 px-6 rounded-full hover:bg-white hover:text-blue-700 hover:font-semibold transition-all"}>
                            Learn&nbsp;More
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    </Container>
}